//-------------------Utho Production----------------------------------------
// const baseUrl = 'https://rest.bosenet.com:'; //For Production
// const formServicePort = '52000'; //For Production
// const uploadServicePort = '52001'; //For Production

const baseUrl = 'https://utho.bosenet.com/xapp/prod/'; //For Production
const formServicePort = 'core'; //For Production
const uploadServicePort = 'documents'; //For Production

const apiUrlFormService = baseUrl + formServicePort;
const apiUrlUploadService = baseUrl + uploadServicePort;

//---------------------Multi Day URL--------------------------------
const formServiceUrl = '/expense/travelexpense/service/v1/expenses';
const baseDataServiceUrl = '/expense/travelexpense/service/v1/basedata';
const employeeListUrl = '/expense/travelexpense/admin/v1/users';
const bkFormServiceUrl = '/expense/travelexpense/service/v1/bk/expenses';
const employeeDashboardUrl = '/expense/travelexpense/service/v1/expenses/dashboard';
const bookeeperDashboardUrl = '/expense/travelexpense/service/v1/bk/expenses/dashboard';
const mockurl = 'http://localhost:3000/fileupload';

//---------------------Single Day URL--------------------------------
const singleDayFormServiceUrl = '/expense/travelexpense/service/v1/single-day/expenses';
/**Microsoft Users details api */
const appId = 'a0899100-73f6-4409-a8d6-6c14578d3511'; //object ID xapp-prod
const msGraphApiUrl = 'https://graph.microsoft.com/v1.0/';
const servicePrincipleUrl = msGraphApiUrl + 'servicePrincipals/' + appId + '/appRoleAssignedTo';
const batchApiUrl = 'https://graph.microsoft.com/v1.0/$batch';
const msClientId = '8268e7ea-b66c-4e3f-9ce2-7f19cfb8fe74';

//--------------------------Report url--------------------------------------
const reportUrl = '/expense/travelexpense/service/v1/expenses/report';

//--------------------------Email url--------------------------------------
const emailUrl = '/expense/travelexpense/service/v1/emails';
const bookeeperTemplateId = '40120428';
const bookeeperRoleId = '4fbe424b-5b66-4148-8e86-d500b5919ccd'; // Bookeeper role id
//------------Firebase Url--------------
const xappUrl = 'https://xapp.bosenet.com/';

export const environment = {
  production: true,
  allowedDomains: [
    new URL(apiUrlFormService).host,
    new URL(apiUrlUploadService).host,
    new URL(msGraphApiUrl).host
  ],
  firebase: {
    apiKey: "AIzaSyDU9w0OKzvEE0CHMdBrghEP54jBeEjZn8Q",
    authDomain: "expense-app-11c59.firebaseapp.com",
    projectId: "expense-app-11c59",
    storageBucket: "expense-app-11c59.appspot.com",
    messagingSenderId: "266567980371",
    appId: "1:266567980371:web:862c5b963a720fdd003da6"
  },
  apiUrl: apiUrlFormService + formServiceUrl,
  apiToGetAllExpenses: apiUrlFormService + formServiceUrl,
  apiToCreateExpenseForm: apiUrlFormService + formServiceUrl,
  apiToCreateSingleDayExpenseForm: apiUrlFormService + singleDayFormServiceUrl,
  apiToUpdateExpenseForm: apiUrlFormService,
  apiToUploadDocuments: apiUrlUploadService + formServiceUrl,
  apiToGetBaseData: apiUrlFormService + baseDataServiceUrl,
  apiToGetAllEmployeeList: apiUrlFormService + employeeListUrl,
  apiToGetAllNotification: apiUrlFormService + formServiceUrl,
  apiToInitiateEmployeDraft: apiUrlFormService + bkFormServiceUrl,
  apiToGetEmployeeTef: apiUrlFormService + employeeDashboardUrl,
  apiToGetBookeeperTef: apiUrlFormService + bookeeperDashboardUrl,
  mockUrl: mockurl,
  apiServicePrinciple: servicePrincipleUrl,
  apiBatch: batchApiUrl,
  msGraphApi: msGraphApiUrl,
  reportApi: apiUrlFormService + reportUrl,
  xappUrl: xappUrl,
  msClientId: msClientId,
  emaiApi: apiUrlFormService + emailUrl,
  bookeeperTemplateId: bookeeperTemplateId,
  bookeeperRoleId: bookeeperRoleId,
};
